import { render, staticRenderFns } from "./forget-password.vue?vue&type=template&id=4a3ec72b&scoped=true&"
import script from "./forget-password.vue?vue&type=script&lang=js&"
export * from "./forget-password.vue?vue&type=script&lang=js&"
import style0 from "./forget-password.vue?vue&type=style&index=0&id=4a3ec72b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3ec72b",
  null
  
)

export default component.exports